import { useState } from "react";
import {
    FaCoins,
} from "react-icons/fa";
import tw from "tailwind-styled-components";
import { MdOutlineChevronRight } from "react-icons/md";
import Tooltip from "../Tooltip";
import moment from "moment";


function SummaryCards({ summaryData, onClick, setSelectedId, selectedId }) {
    // const [selectedId, setSelectedId] = useState(null);

    const summary = [
        {
            amount: "₹" + summaryData?.totalRent || 0,
            subTitle: (summaryData?.todayCollection || '0'),
            monthlyDueDateCollection: summaryData?.monthlyDueDateCollection || {},
            label: `Total Collection`,
            subLabel: `Today's Collection`,
            color: "text-black",
            icon: <FaCoins className="text-green-400" />,
            filter: 'CMT',
        },
        {
            amount: "₹" + summaryData?.totalRentOnly || 0,
            label: `Rent Collection`,
            color: "text-black",
            icon: <FaCoins size={20} className="text-green-400" />,
            filter: 'CMR',
        },
        {
            amount: "₹" + summaryData?.totalSecurity || 0,
            label: `Security Collection`,
            color: "text-black",
            icon: <FaCoins size={20} className="text-green-400" />,
            filter: 'CMS',
        },
        {
            amount: "₹" + summaryData?.totalUtilities || 0,
            label: `Other Collection`,
            color: "text-black",
            icon: <FaCoins size={20} className="text-green-400" />,
            filter: 'OTHERS',
        },
        {
            amount: "₹" + summaryData?.totalViaKipinn || 0,
            subTitle: (summaryData?.totalCharges || '0'),
            subLabel: `Gateway Charges`,
            label: `Using Kipinn App`,
            color: "text-black",
            icon: <FaCoins size={20} className="text-green-400" />,
            filter: 'App',
        },
        {
            amount: "₹" + summaryData?.totalFine || 0,
            label: `Fine Collection`,
            color: "text-black",
            icon: <FaCoins size={20} className="text-green-400" />,
            filter: 'FINE',
        },
        {
            amount: "₹" + summaryData?.totalOnline || 0,
            label: `Online Collection`,
            color: "text-black",
            icon: <FaCoins size={20} className="text-green-400" />,
            filter: 'CMO',
        },
        {
            amount: "₹" + summaryData?.totalOffline || 0,
            label: `Cash Collection`,
            color: "text-black",
            icon: <FaCoins size={20} className="text-green-400" />,
            filter: 'CMC',
        },
    ];

    return (
        <Wrapper>
            <ScrollCard
                style={{
                    scrollBehavior: "smooth",
                }}
            >
                {/* {summary.map((item, index) => (
                    <Card $selected={selectedId === index} index={index} key={index} onClick={() => {
                        setSelectedId(index);
                        onClick(item.filter);
                    }
                    }>
                        <ValueRow>
                            <div className='flex flex-row'>
                                <Value color={item.color}>{item.amount}</Value>
                                {item.subTitle &&
                                    <Tooltip label={item.subLabel}>
                                        <span className="ml-1 mt-auto text-sm text-gray-600 align-middle mb-1">{"(₹" + item.subTitle + ")"}</span>
                                        <span className="cursor-help text-gray-400 text-xs">ⓘ</span>
                                    </Tooltip>
                                }
                            </div>

                        </ValueRow>
                        <Label>
                            {item.label}
                            <ArrowWrap className="arrow">
                                <Chevron />
                            </ArrowWrap>
                        </Label>
                    </Card>
                ))} */}
                {summary.map((item) => {
                    const isSelected = selectedId === item.filter;

                    return (
                        <Card
                            key={item.filter}
                            $selected={isSelected}
                            onClick={() => {
                                setSelectedId(isSelected ? null : item.filter);
                                onClick(isSelected ? "All" : item.filter);
                            }}
                        >
                            <ValueRow>
                                <div className="flex flex-row">
                                    <Value color={item.color}>{item.amount}</Value>

                                    {item.filter === 'CMT' && item.subTitle && (
                                        <Tooltip
                                            label={
                                                <div className="-m-3 w-72 rounded-xl bg-white p-4">
                                                    <div className="mb-3 text-base font-semibold text-gray-800">
                                                        Today's Collection
                                                    </div>

                                                    <div className="flex justify-between gap-6 text-sm">
                                                        <span className="text-gray-600">
                                                            Today's Collection
                                                            </span>
                                                        <span className="font-semibold text-gray-800">
                                                            ₹{item.subTitle}
                                                        </span>
                                                    </div>

                                                    {item.monthlyDueDateCollection &&
                                                        Object.keys(item.monthlyDueDateCollection).length > 0 && (
                                                            <>
                                                                <div className="my-3 border-t border-gray-200" />

                                                                <div className="mb-2 text-base font-semibold text-gray-800">
                                                                    Rent by Due Month
                                                                </div>

                                                                <div className="space-y-2">
                                                                    {Object.entries(
                                                                        item.monthlyDueDateCollection
                                                                    ).map(([month, amount]) => (
                                                                            <div
                                                                                key={month}
                                                                                className="flex justify-between gap-6 text-sm"
                                                                            >
                                                                                <span className="text-gray-600">
                                                                                    {moment(month, "YYYY-MM").format(
                                                                                        "MMM YYYY"
                                                                                        )}
                                                                                </span>
                                                                                <span className="font-medium text-gray-800">
                                                                                    ₹{amount}
                                                                                </span>
                                                                            </div>
                                                                        ))}                                                         
                                                                </div>
                                                            </>
                                                        )}
                                                </div>
                                            }
                                        >
                                            <>
                                                <span className="ml-1 mt-auto mb-1 text-sm text-gray-600">
                                                    (₹{item.subTitle})
                                                </span>
                                                <span className="cursor-help text-xs text-gray-400">ⓘ</span>
                                            </>
                                        </Tooltip>
                                    )}

                                    {item.filter === 'App' && item.subTitle && (
                                        <Tooltip
                                        label={"Gateway Charges"}>
                                            <>
                                                <span className="ml-1 mt-auto mb-1 text-sm text-gray-600">
                                                    (₹{item.subTitle})
                                                </span>
                                                <span className="text-xs text-gray-400">ⓘ</span>
                                            </>
                                        </Tooltip>
                                    )}
                                </div>
                            </ValueRow>
                            <Label>
                                {item.label}
                                <ArrowWrap className="arrow">
                                    <Chevron />
                                </ArrowWrap>
                            </Label>
                        </Card>
                    );
                })}
            </ScrollCard>
        </Wrapper>
    );
}
const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto overflow-y-visible flex space-x-4 py-1`;

const Card = tw.div`
  group min-w-[220px]
  rounded-lg bg-white
  p-4 cursor-pointer
  border border-gray-100
  shadow-sm
  transition-all duration-200
  hover:shadow-md hover:border-gray-200
  ${({ $selected }) =>
        $selected
            ? "border-primary-color shadow-md"
            : ""}
`;


const ValueRow = tw.div`
  flex items-baseline gap-1
`;

const Value = tw.div`
  text-xl font-semibold text-gray-900
`;

const Label = tw.div`
  flex  mt-2 text-sm text-gray-500 items-center justify-between
`;

const ArrowWrap = tw.div`
  flex items-center
  text-gray-300
  transition-all duration-200
`;

const Chevron = tw(MdOutlineChevronRight)`
  text-lg
  transform translate-x-0
  opacity-60
  group-hover:opacity-100
  group-hover:text-gray-500
  group-hover:translate-x-1
`;

export default SummaryCards;
